import { api } from "./api";
import * as endpoints from "../data/links/endpoints";

export async function loginUser(data) {
  return api.post(endpoints.LOGIN_USER, data).then((res) => res);
}

export async function register(data) {
  return api.post(endpoints.REGISTER_USER, data).then((res) => res);
}

export async function recoverPassword(data) {
  let { recoverEmail } = data;
  let raw = {
    email: recoverEmail,
  };
  return api.post(endpoints.RECOVER_PASSWORD, raw).then((res) => res);
}

export async function resetPassword(data) {
  let { pass, c_pass, otp } = data;
  let body = {
    otp: otp,
    password: pass,
    c_password: c_pass,
  };

  return api.post(endpoints.RESET_PASSWORD, body).then((res) => res);
}

export async function verifyEmail(data) {
  return api.post(endpoints.VERIFY_EMAIL, data).then((res) => res);
}
